import { Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getAllSupplierInfo } from "../../services/assortiment/actions";

export function SupplierCarousel(props) {
	const [farmerInfo, setFarmerInfo] = useState("");

	useEffect(() => {
		getAllSupplierInfo(props.loginSuccesful, props.identifyInfo, setFarmerInfo);
	}, []);

	return (
		<div style={{ height: 200, marginTop: 0 }}>
			<Carousel
				autoPlay={false}
				animation={"slide"}
				stopAutoPlayOnHover={true}
				swipe={true}
				indicators={false}
			>
				{farmerInfo !== ""
					? farmerInfo?.map((item, i) => <Item key={i} item={item} />)
					: null}
			</Carousel>
		</div>
	);
}

function Item(props) {
	return (
		<Paper>
			<div>
				{props.item.photo ? (
					<Link
						style={{ textDecoration: "none" }}
						to={{
							pathname: "/supplierinfo",
							state: { from: props.item.id },
						}}
					>
						<div style={{ textAlign: "center" }}>
							<div style={{ position: "relative", width: "100%" }}>
								<img // TODO: images moeten allemaal dezelfde afmetingen hebben
									src={props.item.photo}
									style={{
										maxWidth: "100%",
										height: "200px",
										resize: "contain",
									}}
								/>
								<div className="cardContent">{props.item.name}</div>
							</div>
						</div>
					</Link>
				) : null}
			</div>
		</Paper>
	);
}

function mapStateToProps(state) {
	return {
		loginSuccesful: state.login.data.loginSuccesful,
		identifyInfo: state.identify.identifyInfo,
	};
}

export default connect(mapStateToProps, {})(SupplierCarousel);
